<template>
    <el-dialog v-bind="$attrs" v-on="$listeners" width="972px" @open="onOpen">
        <template #title>
            <h3 class="text-dark text-xl font-medium">{{ title }}</h3>
        </template>
        <div v-show="isLoading" class="h-100 relative flex items-center justify-center">
            <img class="w-20 h-[80px]" src="~@/assets/img/product/loading.gif" />
        </div>
        <el-tabs class="product_tabs" v-model="activeNav" v-show="!isLoading">
            <el-tab-pane label="行程信息" name="tours">
                <ProductRoute class="mt-[5px]" :trip-img="state.trip_image" :tours="state.tour" :expandable="false" max-height="600px" />
            </el-tab-pane>
            <el-tab-pane label="费用说明" name="fee">
                <el-scrollbar :view-style="{ maxHeight: '450px' }">
                    <ProductFee class="mt-[5px]" :include="state.fee_description.include" :notInclude="state.fee_description.not_include" ></ProductFee>
                </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane label="取消政策" name="cancel">
                <el-scrollbar :view-style="{ maxHeight: '450px' }">
                    <product-detail-cancel :content="state.cancel_policy" />
                </el-scrollbar>
            </el-tab-pane>
        </el-tabs>

        <div class="flex items-center justify-center mt-[24px]">
            <el-button type="primary" class="w-[180px]" @click="$emit('update:visible', false)">我知道了</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { ref,defineComponent, onMounted } from '@nuxtjs/composition-api'
import { useAsyncState } from '@vueuse/core';
import { REQUEST_CODES } from '~/constants/const-http';
import { getProductTripTour } from '~/services/product';

import ProductRoute from '~/components/automation/product-detail-route.vue'
import ProductFee from '~/components/automation/product-detail-fee.vue'
// 取消政策
import ProductDetailCancel from "~/components/automation/product-detail-cancel.vue";

// import VResponsive from '@/components/VResponsive/VResponsive.vue'
export default defineComponent({
    name: 'CruiseTripDialog',
    components: { ProductRoute,ProductFee,ProductDetailCancel },
    props: {
        title: {
            type: String,
            default: '庞洛号·巴克里索港（圣克里斯托瓦尔）-巴克里索港（圣克里斯托瓦尔）9天8'
        },
        product_no: String
    },
    setup(props) {
        const {state,execute, isLoading, isReady} = useAsyncState(async () => {
            const {code, data, msg} = await getProductTripTour({
                product_no: props.product_no
            });
            if(code !== REQUEST_CODES.ERROR_OK){
                throw new Error(msg)
            }
            return data;
        }, {
            trip_image: '',
            tour: [],
            cancel_policy: '',
            fee_description:{
                include:"",
                not_include:""
            },
        }, {
            immediate: false
        })
        const activeNav = ref('');
        const fee_description = ref({
            include:"456",
            not_include:"34",
        });
        const cancel_policy = ref("dsfsdfsdf");

        const onOpen = ()=>{
            activeNav.value = 'tours';
            if(!isReady.value){
                execute();
            }
        };
        return {
            state,
            isLoading,
            activeNav,
            fee_description,
            cancel_policy,
            onOpen
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .product_tabs {
  margin-top: -1rem;
}
::v-deep .product_tabs .el-tabs__item {
  color: $color-grey-19;
  font-size: 16px;
}
::v-deep .product_tabs .el-tabs__item:hover, ::v-deep .product_tabs .el-tabs__item.is-active {
  color: $color-black-2;
}
::v-deep .product_tabs .el-tabs__active-bar {
  background-color: $color-black-2;
}
</style>
<style lang="scss" module>
.wraper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.trip_img {
  margin-right: 1rem;
  width: 22.5rem;
}
.trip_table {
  font-size: 1rem;
  line-height: 1.5rem;
  width: 100%;
}
.trip_table_wrap {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
}
.trip_table_head {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
}
.trip_table_head th {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
}
.trip_table_td {
  border-bottom-width: 1px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>
